import React, { useState } from "react";
import { User } from "lucide-react";
import { useAuthContext } from "../context/AuthContext";
import { updateDoc, doc } from "firebase/firestore";
import { db } from "../firebase";
import PageHeader from "../components/layout/PageHeader";
import Button from '../ui/Button';

const ProfilePage: React.FC = () => {
  const { user } = useAuthContext();
  const [displayName, setDisplayName] = useState(user?.displayName || "");
  const [message, setMessage] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  const handleUpdateProfile = async () => {
    if (!user?.uid) return;
    setSaving(true);
    setMessage(null);
    try {
      await updateDoc(doc(db, "users", user.uid), {
        displayName,
      });
      setMessage("Profile updated successfully.");
    } catch (err: any) {
      setMessage(err.message || "Failed to update profile.");
    }
    setSaving(false);
  };

  return (
    <div className="max-w-2xl mx-auto mt-10 px-6">
      <PageHeader 
        icon={<User size={24} />}
        title="My Profile"
        subtitle="Manage your personal information and settings"
      />
      
      <div className="p-6 bg-surface shadow rounded-lg">
        {message && <div className="mb-4 text-sm text-primary bg-primary/10 border border-primary/30 rounded p-2">{message}</div>}
        <div className="text-text-secondary text-sm space-y-4">
        <div>
          <label className="block font-medium text-text-secondary mb-1">Email</label>
          <input
            className="w-full border px-3 py-2 rounded bg-bg-subtle cursor-not-allowed"
            value={user?.email || ""}
            disabled
          />
        </div>
        <div>
          <label className="block font-medium text-text-secondary mb-1">Display Name</label>
          <input
            className="w-full border px-3 py-2 rounded"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
          />
        </div>
        <Button
          variant="primary"
          onClick={handleUpdateProfile}
          disabled={saving}
          className="mt-4 font-semibold"
        >
          {saving ? "Saving..." : "Update Profile"}
        </Button>
      </div>
      </div>
    </div>
  );
};

export default ProfilePage;
